import React, { FC, useState } from 'react';
import { PageWrapper, useShowAlertPopup, ProductForm, Product } from '@dew21/ui';
import axios from 'axios';
import { useHistory } from 'react-router';

export const AddProduct: FC = (props) => {
  const [product, setProduct] = useState<Product | null>(null);
  const history = useHistory();
  const showNotificationBanner = useShowAlertPopup();

  return <PageWrapper
    breadCrumb={[{ title: 'Produkte', path: '/products' }, { title: 'Hinzufügen', path: `/products/add` }]}
    marginal={{
      items: [],
    }}>
    <ProductForm
      onCancel={() => {
        history.push('/products');
      }}
      product={product}
      setProduct={(payload) => {
      const data = {
        product: payload.product,
        attachments: payload.attachments ? payload.attachments : null,
      };
      axios.post(`/api/product/create`, data).then((response) => {
        setProduct(response.data);
        showNotificationBanner({ renderContent: () => <>Das Produkt wurde angelegt.</> });
        history.push('/products');
      }).catch((error) => {
        console.log(error);
      });
    }}/>
  </PageWrapper>;
};
